var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"c-card d-flex flex-column"},[_c('v-skeleton-loader',_vm._b({staticClass:"c-post-skeleton pb-5",attrs:{"types":{
      'post-heading': 'heading',
      'post-excerpt': 'paragraph',
      'post-action-bar': 'button, avatar@2'
    },"type":"image, post-heading, post-excerpt, post-action-bar"}},'v-skeleton-loader',_vm.attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }